import http from 'superagent'

export default class RestService {
    constructor(modelPath) {
        this.modelPath = modelPath
        this.authToken = webase.model.auth_token
        this.http = http
        this.baseUrl = webase.utils.app.getBaseUrl()
    }

    list() {
        let url = this.baseUrl + '/api/v1/' + this.modelPath + '.json?t=' + Date.now()
        return this.executeGet(url)
    }


    get(id) {
        let url = this.baseUrl + '/api/v1/' + this.modelPath + '/' + id + '.json?t=' + Date.now()
        return this.executeGet(url)
    }

    executeGet(url) {
        return new Promise((resolve, reject) => {
            http.get(url)
                .set('x-api-token', this.authToken)
                .end((error, response) => {

                    if (response.status === 200 || response.status === 201) {
                        const data = JSON.parse(response.text)
                        resolve(data)
                    } else {
                        reject(JSON.parse(response.text))
                    }
                })
        });
    }

    create(model) {
        let url = this.baseUrl + '/api/v1/' + this.modelPath + '.json?t=' + Date.now()
        return this.executePost(url, model)
    }

    update(id, model) {
        let url = this.baseUrl + '/api/v1/' + this.modelPath + '/' + id + '.json?t=' + Date.now()
        return this.executePut(url, model)
    }

    executePut(url, model) {
        return new Promise((resolve, reject) => {
            http.put(url)
                .send(model)
                .set('x-api-token', this.authToken)
                .set('Accept', 'application/json')
                .end((error, response) => {
                    if (response.status === 200) {
                        resolve(JSON.parse(response.text))
                    } else {
                        reject(JSON.parse(response.text))
                    }
                })
        })
    }

    executePost(url, model) {
        return new Promise((resolve, reject) => {
            http.post(url)
                .send(model)
                .set('x-api-token', this.authToken)
                .set('Accept', 'application/json')
                .end((error, response) => {
                    if (response.status === 200 || response.status === 201) {
                        resolve(JSON.parse(response.text))
                    } else {
                        reject(JSON.parse(response.text))
                    }
                })
        })
    }

    remove(id) {
        let url = this.baseUrl + '/api/v1/' + this.modelPath + '/' + id + '.json?t=' + Date.now()
        return new Promise((resolve, reject) => {
            http.delete(url)
                .set('x-api-token', this.authToken)
                .set('Accept', 'application/json')
                .end(function (error, response) {
                    if (response.status === 200 || response.status === 204) {
                        response.status === 204 ? resolve() : resolve(JSON.parse(response.text))
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }

    convertToMultpart(data) {
        let formData = new FormData()
        let modelName = Object.keys(data)[0]
        let fieldNames = Object.keys(data[modelName])

        for (let i = 0; i < fieldNames.length; i++) {
            let fieldName = fieldNames[i]

            if (data[modelName][fieldName]) {
                formData.append(`${modelName}[${fieldName}]`, data[modelName][fieldName])
            }
        }

        return formData
    }

}
